import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

export const FooterTable = ({ columns, rows, totalSampleWaterVolume }: any) => {
  const { setValue } = useFormContext();
  const totalRow = rows.find((row: any) => row.id === 1);

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#f5f5f5",
        borderTop: "1px solid #ddd",
        padding: "8px 16px",
      }}
    >
      {columns.map((column: any, index: any) => {
        const columnFlex = column.flex || 1;

        if (index === 0) {
          return (
            <Typography
              key={index}
              variant="body2"
              sx={{
                flex: columnFlex,
                fontWeight: "bold",
                textAlign: column.align || "left",
              }}
            >
              Volumen agua muestra puntual para formar la acumulada (ml).
            </Typography>
          );
        } else if (column.field.startsWith("muestra_")) {
          const muestraValue = parseFloat(totalRow[column.field]) || 0;
          const totalAireMuestreado = totalRow.total_aire_muestreado || 1;
          const calculatedValue =
            (muestraValue * totalSampleWaterVolume) / totalAireMuestreado;

          setValue("muestraValue", muestraValue);
          setValue("totalAireMuestreado", totalAireMuestreado);
          setValue("calculatedValue", calculatedValue);

          return (
            <Typography
              key={index}
              variant="body2"
              sx={{
                flex: columnFlex,
                padding: "0 10px",
                textAlign: column.align || "center",
                borderLeft: "1px solid #ddd",
              }}
            >
              {calculatedValue.toFixed(2)}
            </Typography>
          );
        } else {
          return (
            <Typography
              key={index}
              variant="body2"
              sx={{
                flex: columnFlex,
                borderLeft: "1px solid #ddd",
                textAlign: column.align || "center",
                paddingLeft: "5px",
              }}
            ></Typography>
          );
        }
      })}
    </Box>
  );
};
